import { useMutation, useQuery } from "react-query";
import { Count, ServerError, NameAndId, PageFilter } from "../../data";
import { useAxios } from "../../hooks";

export const useGetAdmins = (filter: AdminFilter) => {
  const path = "/admin-security/api/admins";
  const axios = useAxios();
  return useQuery<Count<AdminData>, ServerError>({
    queryKey: ["admins", filter],
    keepPreviousData: true,
    initialData: { items: [], total: 0 },
    queryFn: () =>
      axios.get(path, {
        params: filter,
      }),
  });
};
export const useGetRoles = () => {
  const path = "/admin-security/api/roles";
  const axios = useAxios();
  return useQuery<NameAndId[], any>({
    queryKey: ["roles"],
    queryFn: () => axios.get(path),
    initialData: [],
  });
};

export const useDeleteAdmin = () => {
  const axios = useAxios();
  return useMutation<unknown, ServerError, string>((id?: string) => {
    const path = `/admin-security/api/admins/${id}`;
    return axios.delete(path);
  });
};

export const useChangeAdminStatus = () => {
  const axios = useAxios();

  return useMutation<unknown, ServerError, string>((id?: string) => {
    const path = `/admin-security/api/admins/${id}/status`;
    return axios.post(path);
  });
};
export const useAddAdmin = () => {
  const axios = useAxios();

  return useMutation<AdminData, ServerError, AddAdminModel>((data) => {
    const path = "/admin-security/api/admins";
    return axios.post(path, data);
  });
};

export const useEditAdmin = () => {
  const axios = useAxios();

  return useMutation<AdminData, ServerError, EditAdminModel>((data) => {
    const path = `/admin-security/api/admins/${data.id}`;
    return axios.post(path, data);
  });
};
export interface AdminFilter extends PageFilter {
  isActive?: boolean;
}
export interface AdminData {
  id: string;
  email: string;
  role: string;
  isActive: boolean;
  firstName: string;
  lastName: string;
  dateAdded: string;
}

export interface AddAdminModel extends EditAdminModel {
  email: string;
}
export interface EditAdminModel {
  role: string;
  lastName: string;
  firstName: string;
  id: string;
}
